import { loadStripe } from "@stripe/stripe-js/pure";
import React from "react";
import { Button } from "semantic-ui-react";
import StripeSetupIntentApp from "../../Stripe/SetupIntent/app";
import CurrentPaymentMethodContent from "../../Subscription/Detail/CurrentPaymentMethodContent";

interface Props {
  session: server.dto.ClientOnboardingSession
  onFinished: (newSession: server.dto.ClientOnboardingSession) => void
}


const Payment = (props: Props) => {
  const [paymentMethod, setPaymentMethod] = React.useState(props.session.paymentSetup?.currentPaymentMethod);
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [stripePromise] = React.useState<ReturnType<typeof loadStripe> | null>(() => loadStripe(site.deploymentValues.stripePublishableKey));

  if (paymentMethod != null) {
    return <>

      <div className="margin-bottom-large">
        <CurrentPaymentMethodContent
          paymentMethod={paymentMethod}
          onChangePaymentMethod={() => { setPaymentMethod(undefined); }}
        />
      </div>

      <div className="grow1 flex" style={{ justifyContent: "flex-end", alignItems: "flex-end" }}>
        <div>
          <Button
            primary
            type="submit"
            onClick={async () => {
              setIsSubmitting(true);
              await window.CoreApi.ClientOnboardingOpen.SetLifecycle({
                secret: props.session.secret,
                lifeCycle: "readyForCreateClientAccount"
              })

              const newSession = await window.CoreApi.ClientOnboardingOpen.GetOnboardingSession(props.session.secret);
              props.onFinished(newSession.data.data);
            }}

            loading={isSubmitting}
            disabled={isSubmitting}
          >
            {RESX.Buttons.btnNextStep}
          </Button>
        </div>
      </div>
    </>;
  }
  return <StripeSetupIntentApp
    stripe={stripePromise}
    config={props.session.paymentSetup.config}
    fetchIntentApi={async (type) => {
      const res = await window.CoreApi.ClientOnboardingOpen.CreateSetupIntent({
        type,
        secret: props.session.secret
      });

      return res.data.data;
    }}
  />;
};

export default Payment;